<template>
  <section class="v metrics">
    <metrics-overview
      v-if="currentUsage"
      :stream-data="streamData"
      :workload="Number(currentUsage.overall.occupied_spaces)"
      :max-val="Number(currentUsage.overall.total_parking_spaces)"
      :line-chart="lineChart"
      @load="onChartLoaded"
    ></metrics-overview>
    <v-layout class="no-margin-top" row wrap fill-height>
      <v-flex xs12 md3 fill-height v-if="currentUsage">
        <!-- <workload
          :workload="detailedWorkloads.eparking"
          label="Auslastung E-Parkplätze"
        ></workload> -->
        <absolute-workload v-if="currentUsage.charging"
          :workload="Number(currentUsage.charging.occupied_spaces)"
          :max-val="Number(currentUsage.charging.total_parking_spaces)"
          label="E-Parkplätze belegt">
        </absolute-workload>
        <absolute-workload v-else
          :workload="0"
          :max-val="0"
          label="E-Parkplätze belegt">
        </absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height v-if="currentUsage">
        <!-- <workload
          :workload="detailedWorkloads.handicapped"
          label="Auslastung Behindertenparkpl."
        ></workload> -->
        <absolute-workload v-if="currentUsage.handicapped"
          :workload="Number(currentUsage.handicapped.occupied_spaces)"
          :max-val="Number(currentUsage.handicapped.total_parking_spaces)"
          label="Behindertenp. belegt">
        </absolute-workload>
        <absolute-workload v-else
          :workload="0"
          :max-val="0"
          label="Behindertenp. belegt">
        </absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height v-if="currentUsage">
        <!-- <workload
          :workload="detailedWorkloads.withRules"
          label="Parkplätze mit Regel"
        ></workload> -->
        <absolute-workload v-if="currentUsage.woman"
          :workload="Number(currentUsage.woman.occupied_spaces)"
          :max-val="Number(currentUsage.woman.total_parking_spaces)"
          label="Eltern-Kind-Parkplätze belegt">
        </absolute-workload>
        <absolute-workload v-else
          :workload="0"
          :max-val="0"
          label="Eltern-Kind-Parkplätze belegt">
        </absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height v-if="currentUsage">
        <!-- <workload
          :workload="detailedWorkloads.normal"
          label="Allgemeine Parkplätze"
        ></workload> -->
        <absolute-workload v-if="currentUsage.normal"
          :workload="Number(currentUsage.normal.occupied_spaces)"
          :max-val="Number(currentUsage.normal.total_parking_spaces)"
          label="Allgemeine Parkplätze">
        </absolute-workload>
        <absolute-workload v-else
          :workload="0"
          :max-val="0"
          label="Allgemeine belegt">
        </absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height v-if="dailyStats">
        <!-- <simple-statistic
          :value="dailyStats.movements"
          type="number"
          label="Parkvorgänge heute"
          clickable
          @item-click="openAllParkProcesses"
        ></simple-statistic> -->
        <simple-statistic
          :value="dailyStats.movements"
          type="number"
          label="Parkvorgänge heute"
        ></simple-statistic>
      </v-flex>
      <!-- <v-flex xs12 md3 fill-height>
        <simple-statistic
          :value="statistics.averageRotations"
          type="number"
          :decimals="1"
          label="ø Parkrotationen heute"
        ></simple-statistic>
      </v-flex> -->
      <v-flex xs12 md3 fill-height>
        <simple-statistic
          :value="statistics.averageParkDuration | durationFromSeconds"
          type="time"
          label="ø Parkdauer heute"
        ></simple-statistic>
      </v-flex>
      <!-- <v-flex xs12 md3 fill-height>
        <simple-statistic
          :value="statistics.exceededParkings"
          type="number"
          label="Überschrittene Parkzeiten"
          color="error"
        ></simple-statistic>
      </v-flex> -->
    </v-layout>
    <!-- <v-dialog
      v-model="dialog"
      scrollable
      lazy
      max-width="1320"
    >
      <v-card>
        <v-card-text>
          <parking-process-table
            :data="$store.parkingLots.state.parkingLots"
          ></parking-process-table>
        </v-card-text>
        <v-card-actions class="text-align-right">
          <v-btn flat color="primary" @click="dialog = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </section>
</template>

<script>
import moment from 'moment';
import MetricsOverview from '../components/Dashboard/MetricsOverview.vue';
// import Workload from '../components/Dashboard/Workload.vue';
import SimpleStatistic from '../components/Metrics/SimpleStatistic.vue';
// import ParkingProcessTable from '../components/Metrics/ParkProcessTable.vue';
import AbsoluteWorkload from '../components/Dashboard/AbsoluteWorkload.vue';

export default {
  name: 'metrics',

  components: {
    MetricsOverview,
    // Workload,
    SimpleStatistic,
    // ParkingProcessTable,
    AbsoluteWorkload,
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    workload() {
      return this.$store.metrics.state.overview.workload;
    },
    streamData() {
      return this.$store.metrics.state.overview.stream;
    },
    lineChart() {
      return this.$store.metrics.state.overview.lineChart;
    },
    detailedWorkloads() {
      return this.$store.metrics.state.detailed.workloads;
    },
    statistics() {
      return this.$store.metrics.state.detailed.statistics;
    },
    currentUsage() {
      return this.$store.metrics.state.currentUsage;
    },
    dailyStats() {
      return this.$store.metrics.state.dailyStats;
    },
  },

  filters: {
    // Parses Seconds into HH:mm duration
    // TODO: this is suposed to represent the average parking duration not the overall
    durationFromSeconds(seconds) {
      seconds = parseInt(seconds, 10);
      const duration = moment.duration(seconds, 'seconds');
      return moment.utc(duration.asMilliseconds()).format('HH:mm');
    },
  },

  methods: {
    onChartLoaded() {
      if (this.lineChart.datasets.length === 0) {
        this.$store.metrics.dispatch('GET_WORKLOAD');
      }
    },
    openAllParkProcesses() {
      this.dialog = true;
    },
  },

  mounted() {
    this.$store.navigation.commit('SET_TABS', [
      { label: 'Dashboard', to: '/' },
      { label: 'Metriken', to: '/metrics' },
    ]);
    this.$store.metrics.dispatch('GET_CURRENT_USAGE');
    this.$store.metrics.dispatch('GET_DAILY_STATS');
    this.$store.metrics.dispatch('GET_LATEST_EVENTS');
    this.$store.parkingLots.dispatch('PARKING_LOT_SOCKET');
  },
};
</script>
